
import { Users } from "lucide-react";

const ExtendedTopics = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
      <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="flex items-center mb-3">
          <Users className="h-6 w-6 text-kaija-slate mr-2" />
          <h3 className="text-xl font-medium">Positiivne psühholoogia</h3>
        </div>
        <p className="text-gray-700">
          Tutvutakse positiivse psühholoogia tehnikatega, mis aitavad meeskonnal arendada tugevamaid suhteid, suurendada empaatiat ja toetada ühist eesmärgi suunas liikumist.
        </p>
      </div>
      
      <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="flex items-center mb-3">
          <Users className="h-6 w-6 text-kaija-slate mr-2" />
          <h3 className="text-xl font-medium">Meeskonna heaolu</h3>
        </div>
        <p className="text-gray-700">
          Töötajate vaimne ja füüsiline heaolu on oluline vastupidavuse jaoks. Tutvutakse praktiliste tööriistadega stressiga toimetulekuks ja enesehoiu oskuste arendamiseks.
        </p>
      </div>
      
      <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="flex items-center mb-3">
          <Users className="h-6 w-6 text-kaija-slate mr-2" />
          <h3 className="text-xl font-medium">Närvisüsteemi regulatsioon</h3>
        </div>
        <p className="text-gray-700">
          Õpitakse tundma, kuidas närvisüsteem reageerib stressile ja pingelistele olukordadele. Uuritakse autonoomse närvisüsteemi tööpõhimõtteid ning arutletakse, kuidas teadlik närvisüsteemi regulatsioon aitab suurendada vastupidavust.
        </p>
      </div>
    </div>
  );
};

export default ExtendedTopics;
